var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Card, Grid, Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { getAnistia } from "../../apis/api";
import CardProprietario from "../../components/CardProprietario";
import CardVeiculo from "../../components/CardVeiculo";
import Loader from "../../components/Loading";
import TableListDebitos from "../../components/TableListDebitos";
import styles from "./index.module.css";
import EvaluationButton from "../../components/EvaluationButton";
var DebitosIpva = function () {
    var location = useLocation();
    var locationState = location.state;
    var _a = React.useState(locationState || null), response = _a[0], setResponse = _a[1];
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var history = useHistory();
    React.useEffect(function () {
        if (!locationState) {
            toast.warn("Por favor, selecione um veículo para consultar os débitos.");
            history.push("/");
        }
    }, [locationState, history]);
    function handleVeiculos() {
        history.push("/");
    }
    function handleDebitosAnistia() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var renavan, anistiaResponse, debitosAnistia, error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.conteudoSaida) === null || _b === void 0 ? void 0 : _b.conteudoSaida)) {
                            toast.error("Dados de débitos não disponíveis");
                            return [2 /*return*/];
                        }
                        if (!response.data.conteudoSaida.conteudoSaida
                            .possuiDebitosElegiveisParaAnistia) {
                            toast.warning("Este veículo não possui débitos elegíveis para anistia conforme Lei 8.201/2023");
                            return [2 /*return*/];
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, 4, 5]);
                        setLoading(true);
                        renavan = response.data.conteudoSaida.conteudoSaida.renavam;
                        return [4 /*yield*/, getAnistia(Number(renavan))];
                    case 2:
                        anistiaResponse = _c.sent();
                        if (anistiaResponse.data.status === "SUCESSO") {
                            debitosAnistia = anistiaResponse.data.data.conteudoSaida.conteudoSaida;
                            if (!debitosAnistia ||
                                !debitosAnistia.debitos ||
                                debitosAnistia.debitos.length === 0) {
                                toast.warning("Não foram encontrados débitos elegíveis para anistia neste momento");
                                return [2 /*return*/];
                            }
                            history.push({
                                pathname: "/dar-ipva/anistia",
                                state: debitosAnistia,
                            });
                        }
                        else {
                            toast.error("Não foi possível buscar dados da anistia");
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _c.sent();
                        toast.error("Erro ao buscar informações de anistia. Por favor, tente novamente mais tarde.");
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    if (!response) {
        return null;
    }
    return (_jsx(_Fragment, { children: _jsxs(Box, { children: [_jsx(Loader, { open: loading, sx: { color: "#fff" }, zIndex: 999 }), _jsx(Typography, __assign({ variant: "subtitle1", align: "center" }, { children: _jsx(Card, __assign({ sx: {
                            py: 2,
                            px: { xs: 2, md: 6 },
                        } }, { children: _jsxs(Grid, __assign({ container: true }, { children: [_jsxs(Grid, __assign({ item: true, xs: 12 }, { children: [_jsxs(Grid, __assign({ container: true, justifyContent: "space-between", alignItems: "center", className: styles.containerHeader }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, md: 4, sm: 4, lg: 4 }, { children: _jsx(Typography, __assign({ variant: "h5", fontWeight: "bold", className: styles.textTitle }, { children: "IPVA" })) })), _jsx(Grid, __assign({ item: true, xs: 12, md: 4, sm: 4, lg: 4, textAlign: "right" }, { children: _jsx(Button, __assign({ onClick: handleVeiculos, variant: "contained", style: { backgroundColor: "#007932", fontWeight: "bold" }, className: styles.botao }, { children: "Meus Ve\u00EDculos" })) }))] })), _jsx("hr", {})] })), _jsx(CardVeiculo, { data: response.data }), _jsx(CardProprietario, { data: response.data }), _jsx(TableListDebitos, { data: response.data }), response.data.conteudoSaida.conteudoSaida
                                    .possuiDebitosElegiveisParaAnistia && (_jsx(Grid, __assign({ item: true, xs: 12, mt: 5, textAlign: "right" }, { children: _jsx(Tooltip, __assign({ describeChild: true, title: "Para d\u00E9bitos de IPVA eleg\u00EDveis, conforme Lei 8.201/2023. Data limite: ".concat(response.data.conteudoSaida.conteudoSaida
                                            .dataLimiteAnistia
                                            ? new Date(response.data.conteudoSaida.conteudoSaida.dataLimiteAnistia).toLocaleDateString("pt-BR")
                                            : "31/03/2026") }, { children: _jsx(Button, __assign({ variant: "contained", style: { backgroundColor: "#007932", fontWeight: "bold" }, className: styles.botao, onClick: function () { return handleDebitosAnistia(); } }, { children: "Gerar Anistia IPVA" })) })) })))] })) })) })), process.env.EMITIR_DAR_DO_IPVA && (_jsx(EvaluationButton, { idService: process.env.EMITIR_DAR_DO_IPVA }))] }) }));
};
export default DebitosIpva;
